export default __webpack_public_path__ + "static/media/order-hd-600.cfb44dff.jpg";